import React from "react";
import { Outlet, ScrollRestoration } from "react-router";
import { ErrorBoundary, Toast } from "@sscs/ui";
import Content from "./Content/Content";
import Footer from "./Footer/Footer";
import styles from "./publicLayout.module.scss";

const PublicLayout = (): React.JSX.Element => {
  return (
    <div className={styles["layout-root"]}>
      <ScrollRestoration
        getKey={(location) => {
          /* we want to restore scroll not just when user uses front/back
           * browser navigation but when they visit new link too
           * https://reactrouter.com/en/main/components/scroll-restoration
           *
           * For now it only impacts reports since nothing else has sticky navigation header
           */
          return location.pathname;
        }}
      />
      <Content>
        <ErrorBoundary key="content">
          <Outlet />
        </ErrorBoundary>
      </Content>
      <ErrorBoundary key="footer">
        <Footer />
      </ErrorBoundary>
      {/* Toast container needs to be within react router component so router links will work in toasts */}
      <Toast.Container />
    </div>
  );
};

export default PublicLayout;
